import { Radio } from "antd";
import { Select } from "antd";
import React, { FC } from "react";
import {
  IFetchAllDetails,
  IPatientState,
} from "../../../../../interfaces/IPatient";
import { FormErrors } from "../PreAuthIhx";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { Option } = Select;

type TreatmentDetailsProps = {
  formData: any;
  handleInputChange: any;
  errors: FormErrors;
  portalSubmission: boolean;
  treatmentDataOptions: any;
  currentTreatmentFields: any;
  renderTreatmentField: any;
  diagnosisOptions: any;
  roomTypeOptions: any;
  generalRoomTypeOptions: any;
  procedureOptions: any;
  patientStore: IPatientState;
  proposedLineOfTreatment: any;
  isApproved: boolean;
};

const TreatmentDetails: FC<TreatmentDetailsProps> = ({
  formData,
  handleInputChange,
  errors,
  portalSubmission,
  treatmentDataOptions,
  currentTreatmentFields,
  renderTreatmentField,
  diagnosisOptions,
  roomTypeOptions,
  generalRoomTypeOptions,
  procedureOptions,
  patientStore,
  proposedLineOfTreatment,
  isApproved,
}) => {
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          //   margin: "16px 0",
          fontWeight: "bold",
          marginBottom: "16px",
        }}
      >
        Treatment Details
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          //   padding: "15px 55px",
          gap: 10,
        }}
      >
        <div>
          <label>Covid Case</label>
          <Radio.Group
            value={formData.isCovidCase}
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
            onChange={(e) => handleInputChange("isCovidCase", e.target.value)}
            style={{
              display: "flex",
              marginTop: "10px",
              flexDirection: "column",
            }}
          >
            <div>
              <Radio value="yes">YES</Radio>
              <Radio value="no">NO</Radio>
            </div>
          </Radio.Group>
        </div>
        <div>
          <label>
            Proposed Line of Treatment <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            value={formData.proposedLineOfTreatment}
            onChange={(value, option) =>
              handleInputChange("proposedLineOfTreatment", value, option)
            }
            style={{ width: "100%", marginTop: "10px", maxWidth: 300 }}
            status={errors.proposedLineOfTreatment ? "error" : ""}
            placeholder="Select Proposed line of treatment"
            showSearch
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
            // loading={loading.treatment}
          >
            {proposedLineOfTreatment?.map((option: any) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
          {/* <Radio.Group
            value={formData.proposedLineOfTreatment}
            disabled={portalSubmission || isApproved}
            onChange={(e) =>
              handleInputChange("proposedLineOfTreatment", e.target.value)
            }
            style={{
              display: "flex",
              marginTop: "10px",
              flexDirection: "column",
            }}
          >
            <div>
              {proposedLineOfTreatment?.map((option: any) => (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ))}
            //   <Radio value="Medical Management::1112">Medical Management</Radio>
            //   <Radio value="Intensive Care::1113">INTENSIVE CARE</Radio>
            //   <Radio value="Investigation::1114">INVESTIGATION</Radio>
            //   <Radio value="Surgical Management::1123">
            //     SURGICAL MANAGEMENT
            //   </Radio>
            </div>
          </Radio.Group> */}
          {errors.proposedLineOfTreatment && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.proposedLineOfTreatment}
            </div>
          )}
        </div>
        <div>
          <label>
            Treatment <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            value={formData.treatment}
            onChange={(value, option) =>
              handleInputChange("treatment", value, option)
            }
            style={{ width: "100%", marginTop: "10px", maxWidth: 300 }}
            status={errors.procedure ? "error" : ""}
            placeholder="Select treatment"
            showSearch
            disabled={
              !formData.proposedLineOfTreatment ||
              portalSubmission
            }
            // loading={loading.treatment}
          >
            {treatmentDataOptions?.map((option: any) => (
              <Option
                key={option.value}
                value={option.value}
                treatment={option.label}
              >
                {option.label}
              </Option>
            ))}
          </Select>
          {errors.treatment && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.treatment}
            </div>
          )}
        </div>
        <div>
          <label>
            Diagnosis <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            mode="multiple"
            style={{ width: "100%", marginTop: "10px", maxWidth: 300 }}
            placeholder="Select diagnosis"
            value={formData.diagnosis}
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
            onChange={(values, options) =>
              handleInputChange(
                "diagnosis",
                values, // selected labels
                options // full option objects
              )
            }
            optionLabelProp="label"
          >
            {diagnosisOptions?.map((option: any) => (
              <Option
                key={option.value}
                value={option.label}
                label={option.label}
              >
                {option.label}
              </Option>
            ))}
          </Select>
          {errors.diagnosis && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.diagnosis}
            </div>
          )}
        </div>
        <div>
          <label>
            Procedure <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            mode="multiple"
            style={{ width: "100%", marginTop: "10px", maxWidth: 300 }}
            placeholder="Select procedure"
            value={formData.procedure}
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
            onChange={(values, options) =>
              handleInputChange(
                "procedure",
                values, // selected labels
                options // full option objects
              )
            }
            optionLabelProp="label"
          >
            {procedureOptions?.map((option: any) => (
              <Option
                key={option.value}
                value={option.label}
                label={option.label}
              >
                {option.label}
              </Option>
            ))}
          </Select>
          {errors.procedure && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.procedure}
            </div>
          )}
        </div>
        {/* {currentTreatmentFields?.length > 0 && (
          <div
            style={{
              gridColumn: "1 / -1",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 20,
            }}
          >
            <h3 style={{ gridColumn: "1 / -1" }}>Treatment Specific Fields</h3>
            {currentTreatmentFields?.map((field: any, index: any) => (
              <div key={index}>
                <label>
                  {field.fieldName} <span style={{ color: "red" }}>*</span>
                </label>
                {renderTreatmentField(field)}
              </div>
            ))}
          </div>
        )} */}
        {currentTreatmentFields?.length > 0 && (
          <>
            <div
              style={{
                gridColumn: "1 / -1",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Treatment Specific Fields
            </div>
            {currentTreatmentFields?.map((field: any, index: any) => (
              <div key={index}>
                <label>
                  <p style={{ marginBottom: "0.6rem" }}>
                    {field.fieldName} <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                {renderTreatmentField(field)}
              </div>
            ))}
          </>
        )}

        <div>
          <label>
            Room Type <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            value={formData.roomType}
            onChange={(value, option) =>
              handleInputChange("roomType", value, option)
            }
            style={{ width: "100%", marginTop: "10px" }}
            status={errors.roomType ? "error" : ""}
            placeholder="Select room type"
            // disabled={portalSubmission || isApproved}
            disabled={portalSubmission}
            showSearch
            // loading={loading.roomType}
          >
            {roomTypeOptions?.map((option: any) => (
              <Option key={option.value} value={option.label}>
                {option.label}
              </Option>
            ))}
          </Select>
          {errors.roomType && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {errors.roomType}
            </div>
          )}
        </div>
        <div>
          <label>
            Expected DATE OF DISCHARGE <span style={{ color: "red" }}>*</span>
          </label>
          <DatePicker
            value={
              formData.dod
                ? dayjs(formData.dod, "DD-MM-YYYY HH:mm:ss")
                : null
            }
            style={{ width: "100%", marginTop: "10px" }}
            format={"DD-MM-YYYY HH:mm:ss"}
            onChange={(date) => handleInputChange("dod", date)}
            // disabled={isApproved || portalSubmission}
            disabled={portalSubmission}
          />
          {errors.dod && (
            <div style={{ color: "red", fontSize: "12px" }}>{errors.dod}</div>
          )}
        </div>
        {formData?.roomType?.toLowerCase() === "others" && (
          <div>
            <label>
              General Room Type <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              value={formData.otherRoomType}
              onChange={(value, option) =>
                handleInputChange("otherRoomType", value, option)
              }
              style={{ width: "100%", marginTop: "10px" }}
              status={errors.otherRoomType ? "error" : ""}
              placeholder="Select general room type"
              // disabled={portalSubmission || isApproved}
              disabled={portalSubmission}
              showSearch
              // loading={loading.roomType}
            >
              {generalRoomTypeOptions?.map((option: any) => (
                <Option key={option.value} value={option.label}>
                  {option.label}
                </Option>
              ))}
            </Select>
            {/* {errors.roomType && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.roomType}
                            </div>
                          )} */}
          </div>
        )}
        {patientStore?.fetchBasicDetails?.casesResponse?.schemeMetaDataName
          ?.toUpperCase()
          ?.includes("HDFC ERGO General Insurance"?.toUpperCase()) ? (
          <div>
            <label>
              Doctor Specialization <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              mode="multiple"
              style={{ width: "100%", marginTop: "10px" }}
              placeholder="Select Specialization"
              value={formData.specialization}
              // disabled={portalSubmission || isApproved}
              disabled={portalSubmission}
              onChange={(values, options) =>
                handleInputChange(
                  "specialization",
                  values, // selected labels
                  options // full option objects
                )
              }
              optionLabelProp="label"
            >
              {/* {procedureOptions.map((option: any) => (
                              <Option
                                key={option.value}
                                value={option.label}
                                label={option.label}
                              >
                                {option.label}
                              </Option>
                            ))} */}
            </Select>
            {errors.specialization && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {errors.specialization}
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default TreatmentDetails;
